import _get from 'lodash/get';
import _set from 'lodash/set';
import _sortBy from 'lodash/sortBy';

export function getUniqueOptions<TData>(
    allItems: TData[],
    preFilterConfig: PreFilterConfig,
): DropdownInputOption[] {
    const {
        emptyOption,
        fieldValuePath,
        filterValuePath,
        getDropdownOptionLabel,
    } = preFilterConfig;

    const usedValues = new Set<PreFilterPrimitive>();

    const options = allItems.reduce(
        (
            accumulator: DropdownInputOption[],
            currentItem: TData,
        ): DropdownInputOption[] => {
            const fieldValueRaw: PreFilterPrimitive = _get(
                currentItem,
                fieldValuePath,
            );

            let fieldValue: string | number | undefined;

            if (typeof fieldValueRaw === 'string') {
                fieldValue = fieldValueRaw.trim();
            }

            if (typeof fieldValueRaw === 'number') {
                fieldValue = fieldValueRaw;
            }

            if (
                typeof fieldValue === 'string' &&
                fieldValue.length > 0 &&
                !usedValues.has(fieldValue)
            ) {
                const label = getDropdownOptionLabel
                    ? getDropdownOptionLabel(currentItem, fieldValue)
                    : fieldValue;

                const dropdownInputOption: DropdownInputOption = {
                    id: fieldValue.toString(),
                    label,
                    value: {},
                };

                _set(dropdownInputOption, filterValuePath, fieldValue);

                accumulator.push(dropdownInputOption);

                usedValues.add(fieldValue);
            }

            return accumulator;
        },
        [] as DropdownInputOption[],
    );

    const sortedOptions = _sortBy(options, 'label');

    if (emptyOption) {
        sortedOptions.unshift(emptyOption);
    }

    return sortedOptions;
}
